module.exports = __webpack_public_path__ + "static/media/notification_open.083079cf.svg";